import { CoreFilters } from '@/components/filters/core-filters';

export class LectorsFilter extends CoreFilters {
  $filters;
  $list;
  listItem = '.lector-list-item';
  $forShow;
  $loadMore;
  $hideAll;
  $empty;
  showItems = 16;
  showItemsStep = 16;
  specializations = [];
  letter = '';
  text = '';

  constructor() {
    super();
    this.init();
  }

  init() {
    this.$filters = $('.lector-list-filters');

    if (!this.$filters || this.$filters.length === 0) return;

    this.$list = $('.lector-list');
    this.$loadMore = $('.lectors-load-more');
    this.$hideAll = $('.lectors-hide-all');
    this.$empty = $('.lectors-empty');

    this.initAllListeners();
    this.initLoadMore();

    this.filterData();
  }

  initLoadMore() {
    this.$loadMore.on('click', () => {
      this.showItems += this.showItemsStep;
      this.showFiltered(this.$forShow, this.showItems);
      this.checkLoadMore(
        this.$forShow,
        this.$loadMore,
        this.$hideAll,
        this.$empty,
        this.showItems,
        this.showItemsStep
      );
    });

    this.$hideAll.on('click', () => {
      this.showItems = this.showItemsStep;
      this.showFiltered(this.$forShow, this.showItems);
      this.checkLoadMore(
        this.$forShow,
        this.$loadMore,
        this.$hideAll,
        this.$empty,
        this.showItems,
        this.showItemsStep
      );
    });
  }

  initAllListeners() {
    let timer;
    const $letters = $('.lector-list-filters-letters').find('span');
    const $text = $('.lectors-filter-text');

    $('.lectors-filter-specialization').on('change', (e) => {
      const $t = $(e.currentTarget);
      this.specializations = $t.val();
      this.filterData();
    });

    $text.on('keyup', (e) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        const $t = $(e.currentTarget);
        this.text = $t.val();
        this.letter = '';
        $letters.removeClass('active');
        this.filterData();
      }, 1000);
    });

    $letters.on('click', (e) => {
      const $t = $(e.currentTarget);
      this.text = '';
      $text.val('');
      if ($t.is('.active')) {
        this.letter = '';
        $t.removeClass('active');
      } else {
        $letters.removeClass('active');
        this.letter = $t.text();
        $t.addClass('active');
      }

      this.filterData();
    });
  }

  filterData() {
    const $items = this.$list.find(this.listItem);
    $items.addClass('filter-hide').removeClass('filter-for-show');

    $items.each((i, el) => {
      const $t = $(el);
      let toShow = true;
      const filters = {
        specializations: false,
        text: false,
        letter: false,
      };

      if (this.specializations.length > 0) {
        let specializations = $t.data('specializations');
        if (specializations) {
          specializations = specializations.split(',');

          filters.specializations = specializations.some(
            (r) => this.specializations.indexOf(r) >= 0
          );
        } else {
          filters.specializations = false;
        }
      } else {
        filters.specializations = true;
      }

      if (this.text.length > 0) {
        filters.text = $t
          .data('name')
          .toLowerCase()
          .includes(this.text.toLowerCase());
      } else {
        filters.text = true;
      }

      if (this.letter.length > 0) {
        filters.letter =
          $t.data('name').toLowerCase().charAt(0) === this.letter.toLowerCase();
      } else {
        filters.letter = true;
      }

      if (!filters.specializations || !filters.text || !filters.letter) {
        toShow = false;
      }

      if (toShow) $t.addClass('filter-for-show');
    });

    this.$forShow = this.$list.find(this.listItem + '.filter-for-show');

    this.showFiltered(this.$forShow, this.showItems);
    this.checkLoadMore(
      this.$forShow,
      this.$loadMore,
      this.$hideAll,
      this.$empty,
      this.showItems,
      this.showItemsStep
    );
  }
}
